export const addDashIfZero = (value) => {
    let newValue;
    if (value === 0) {
        newValue = "-";
    }
    else {
        newValue = value.toString();
    }
    return newValue;
};
export const addDashForFalsyValue = (value, showNA = false) => !!value && value !== "0" && value !== "0.00"
    ? value === null || value === void 0 ? void 0 : value.toString()
    : showNA
        ? "NA"
        : "-";
export const addDashIfNullOrUndefined = (value) => {
    let newValue;
    if (value === "" ||
        value === undefined ||
        value == null ||
        value === "-" ||
        value === " ") {
        newValue = "-";
    }
    else {
        newValue = value.toString();
    }
    return newValue;
};
export const checkValue = (n) => {
    if (n === "" || n === undefined || n === null || n === "-") {
        return "--";
    }
    return n;
};
export const roundUpToTwoDecimalPlaces = (value) => {
    let newValue = value.toString();
    if (value !== 0)
        newValue = value.toFixed(2);
    if (Number.isNaN(value))
        return "-";
    return newValue;
};
export const addCommas = (n, showZero, defaultVal, maximumFractionDigits) => {
    if (n !== null && n !== undefined && n !== "" && n !== "-" && n !== "--") {
        if (typeof n === "number") {
            if (Number(n) === 0 && (showZero === undefined || showZero === false)) {
                return defaultVal ? defaultVal : "-";
            }
            return n.toLocaleString("en-IN", {
                maximumFractionDigits: maximumFractionDigits
                    ? maximumFractionDigits
                    : 2,
                minimumFractionDigits: 2,
            });
        }
        if (typeof n === "string") {
            //to check summarized values
            if (n.slice(-1) === "K" || n.slice(-1) === "L" || n.slice(-2) === "Cr") {
                return n;
            }
            else {
                if ((n === "0" || Number(n) === 0) &&
                    (showZero === undefined || showZero === false)) {
                    return defaultVal ? defaultVal : "-";
                }
                return Number(n).toLocaleString("en-IN", {
                    maximumFractionDigits: maximumFractionDigits
                        ? maximumFractionDigits
                        : 2,
                    minimumFractionDigits: 2,
                });
            }
        }
    }
    else {
        return defaultVal ? defaultVal : "-";
    }
};
export const addCommasWithoutDecimal = (n, showZero, defaultVal, maximumFractionDigits) => {
    const result = addCommas(n, showZero, defaultVal, maximumFractionDigits);
    return result !== "-" ? result.split(".")[0] : result;
};
export const validateVal = (val) => {
    return val && (val === "" || val === "-" || val === "--");
};
export const validateisNumber = (evt) => {
    //Float validation
    var ASCIICode = evt.which ? evt.which : evt.keyCode;
    if (ASCIICode != 190 && ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
        return evt.preventDefault();
    return true;
};
export const roundUpTonDecimals = (n, val) => {
    let newValue = parseFloat(val);
    if (Number.isNaN(newValue))
        return "-";
    return addCommas(newValue.toFixed(n));
};
export const addCommasWithConditionalDecimal = (n, showZero, defaultVal) => {
    const result = addCommas(n, showZero, defaultVal);
    if (result !== "-" && +result.split(".")[1] == 0) {
        return result.split(".")[0];
    }
    else {
        return result;
    }
};
